<template>
  <CFooter>
    <div class="ms-auto">
      <span class="me-1" target="_blank"
        >&copy; {{ new Date().getFullYear() }}</span
      >
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>
